/* src/views/logements/proto/LivretProto.jsx — LES PIÈCES PARTAGÉES des
   onglets Instructions et Livret de la fiche logement, transcrites de
   docs/handoff/logements-1-fiche.jsx (livré 2026-08-27) : la carte d'état
   du livret, le renvoi « viennent des Instructions », la bascule à quatre
   sections, l'aperçu voyageur (contenu, pas dessin), les cartes des blocs
   automatiques, l'interrupteur rond. LE DESSIN, PAS LA LOGIQUE. */

import React from 'react'

/* ── la carte d'état : « Livret publié » + compteurs ──────────────── */
export function CarteLivretEtat({ publie, nbModules, nbQuestions }) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '11px',
      background: '#fff', borderRadius: '14px', padding: '11px 13px',
      marginBottom: '12px',
      boxShadow: '0 1px 3px rgba(35,50,64,.08),0 0 0 1px rgba(35,50,64,.05)' }}
      data-testid="livret-etat">
      <span style={{ width: '34px', height: '34px', borderRadius: '10px',
        background: publie ? 'var(--vert-bg)' : 'var(--ambre-bg)',
        color: publie ? 'var(--vert-tx)' : 'var(--ambre-tx)', display: 'flex',
        alignItems: 'center', justifyContent: 'center', fontSize: '15px',
        flexShrink: '0' }}>◈</span>
      <span style={{ flex: '1', minWidth: '0' }}>
        <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600',
          color: 'var(--navy-d)' }}>{publie ? 'Livret publié' : 'Livret en brouillon'}</span>
        <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
          marginTop: '1px', lineHeight: '1.45' }}>
          {publie
            ? 'le voyageur l’ouvre par QR code, ou par le lien du message d’arrivée'
            : 'le voyageur voit « livret en cours de préparation »'}</span>
      </span>
      <span style={{ display: 'flex', gap: '14px', flexShrink: '0' }}>
        <span style={{ textAlign: 'right' }}>
          <b style={{ display: 'block', fontSize: '15px', color: 'var(--navy-d)',
            lineHeight: '1' }}>{nbModules}</b>
          <span style={{ display: 'block', fontSize: '9px', color: 'var(--gris-d)',
            marginTop: '2px' }}>modules</span>
        </span>
        <span style={{ textAlign: 'right' }}>
          <b style={{ display: 'block', fontSize: '15px', color: 'var(--navy-d)',
            lineHeight: '1' }}>{nbQuestions}</b>
          <span style={{ display: 'block', fontSize: '9px', color: 'var(--gris-d)',
            marginTop: '2px' }}>question{nbQuestions > 1 ? 's' : ''}</span>
        </span>
      </span>
    </div>
  )
}

/* ── le renvoi « Adresse, wifi, codes et règles » → Instructions ──── */
export function RenvoiInstructions({ onClick }) {
  return (
    <button onClick={onClick} data-testid="livret-renvoi-instructions"
      style={{ display: 'flex', alignItems: 'center', gap: '10px', width: '100%',
        textAlign: 'left', background: '#f6f8fa', border: '1px solid var(--bord)',
        borderRadius: '12px', padding: '10px 12px', minHeight: '54px',
        marginBottom: '12px', cursor: 'pointer' }}>
      <span style={{ width: '26px', height: '26px', borderRadius: '8px',
        background: '#fff', border: '1px solid var(--bord)', color: '#5c6773',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '12px', flexShrink: '0' }}>↻</span>
      <span style={{ flex: '1', minWidth: '0' }}>
        <span style={{ display: 'block', fontSize: '11.5px', fontWeight: '600',
          color: 'var(--navy-d)' }}>Adresse, wifi, codes et règles</span>
        <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
          marginTop: '1px' }}>viennent des Instructions — rien à ressaisir ici</span>
      </span>
      <span style={{ fontSize: '14px', color: 'var(--gris-d)', flexShrink: '0' }}>›</span>
    </button>
  )
}

/* ── la bascule des quatre sections du livret ─────────────────────── */
export function BasculeLivret({ actif, onSec, nbContenu, nbAuto }) {
  const secs = [
    { id: 'contenu', lb: 'Le contenu', n: nbContenu },
    { id: 'auto', lb: 'Automatique', n: nbAuto },
    { id: 'allure', lb: 'L’allure' },
    { id: 'liens', lb: 'Les liens' },
  ]
  return (
    <div style={{ display: 'flex', gap: '3px', background: '#eef2f6',
      borderRadius: '10px', padding: '3px', marginBottom: '12px',
      overflowX: 'auto', scrollbarWidth: 'none', touchAction: 'pan-x' }}>
      {secs.map((s) => (
        <button key={s.id} onClick={() => onSec(s.id)}
          data-testid={`livret-sec-${s.id}`}
          style={actif === s.id
            ? { flex: '0 0 auto', minHeight: '38px', padding: '0 12px',
              borderRadius: '8px', fontSize: '11.5px', whiteSpace: 'nowrap',
              background: '#fff', color: 'var(--navy-d)', fontWeight: '600',
              boxShadow: '0 1px 3px rgba(35,50,64,.12)', border: 'none',
              cursor: 'pointer' }
            : { flex: '0 0 auto', minHeight: '38px', padding: '0 12px',
              borderRadius: '8px', fontSize: '11.5px', whiteSpace: 'nowrap',
              color: 'var(--gris)', background: 'transparent', border: 'none',
              cursor: 'pointer' }}>
          {s.lb}{s.n != null && (
            <span style={{ fontSize: '9.5px', color: 'var(--gris-d)',
              marginLeft: '5px' }}>{s.n}</span>
          )}
        </button>
      ))}
    </div>
  )
}

/* ── le cadre « le livret reste tel qu'il est aujourd'hui » ───────── */
export function CadreApercuNote() {
  return (
    <div style={{ display: 'flex', gap: '9px', background: '#eef2f6',
      border: '1px dashed #c3cdd6', borderRadius: '12px', padding: '10px 11px',
      marginBottom: '10px' }}>
      <span style={{ width: '22px', height: '22px', borderRadius: '6px',
        background: '#fff', border: '1px solid var(--bord)', color: 'var(--gris)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        fontSize: '11px', flexShrink: '0' }}>↻</span>
      <span style={{ flex: '1', minWidth: '0', fontSize: '10.5px',
        color: 'var(--gris-d)', lineHeight: '1.5' }}>Le livret du voyageur reste{' '}
        <b>tel qu'il est aujourd'hui</b>. Ce qui suit en montre le contenu,
        pas le dessin.</span>
    </div>
  )
}

/* ── l'aperçu voyageur (le CONTENU du livret, pas son dessin) ─────── */
export function ApercuLivretVoyageur({ titre, photoUrl, wifi, modules,
  alentoursLigne, nbFaq, guideVide }) {
  return (
    <div style={{ background: '#fff', borderRadius: '16px', overflow: 'hidden',
      boxShadow: '0 1px 3px rgba(35,50,64,.08),0 0 0 1px rgba(35,50,64,.05)' }}
      data-testid="livret-apercu">
      <div style={{ height: '78px',
        background: 'linear-gradient(135deg,#c3d5e4,#87b8e6)', display: 'flex',
        alignItems: 'flex-end', padding: '11px 13px', position: 'relative',
        overflow: 'hidden' }}>
        {photoUrl && (
          <img src={photoUrl} alt="" style={{ position: 'absolute', inset: 0,
            width: '100%', height: '100%', objectFit: 'cover' }} />
        )}
        <span style={{ position: 'relative', fontSize: '14px', fontWeight: '600',
          color: '#fff', textShadow: photoUrl ? '0 1px 3px rgba(35,50,64,.6)' : 'none' }}>{titre}</span>
      </div>
      <div style={{ padding: '12px 13px' }}>
        <div style={{ display: 'flex', gap: '7px', marginBottom: '12px' }}>
          {['Appeler', 'Message', 'Y aller'].map((a) => (
            <span key={a} style={{ flex: '1', textAlign: 'center',
              padding: '8px 4px', borderRadius: '10px', background: '#f6f8fa',
              fontSize: '10px', color: 'var(--navy)' }}>{a}</span>
          ))}
        </div>
        {wifi && (
          <div style={{ padding: '9px 0', borderTop: '1px solid var(--bord)' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--navy-d)',
              margin: '0 0 4px' }}>Le wifi</p>
            <p style={{ fontSize: '10.5px', color: 'var(--gris)', margin: '0',
              lineHeight: '1.5' }}>{wifi}</p>
          </div>
        )}
        {modules.map((m) => (
          <div key={m} style={{ padding: '9px 0', borderTop: '1px solid var(--bord)' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--navy-d)',
              margin: '0' }}>{m}</p>
          </div>
        ))}
        {alentoursLigne && (
          <div style={{ padding: '9px 0', borderTop: '1px solid var(--bord)' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--navy-d)',
              margin: '0 0 4px' }}>Aux alentours</p>
            <p style={{ fontSize: '10.5px', color: 'var(--gris)', margin: '0',
              lineHeight: '1.5' }}>{alentoursLigne}</p>
          </div>
        )}
        {nbFaq > 0 && (
          <div style={{ padding: '9px 0', borderTop: '1px solid var(--bord)' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--navy-d)',
              margin: '0 0 4px' }}>Questions fréquentes</p>
            <p style={{ fontSize: '10.5px', color: 'var(--gris)', margin: '0',
              lineHeight: '1.5' }}>{nbFaq} question{nbFaq > 1 ? 's' : ''}</p>
          </div>
        )}
        {guideVide && (
          <div style={{ padding: '9px 0', borderTop: '1px solid var(--bord)' }}>
            <p style={{ fontSize: '11px', fontWeight: '600', color: 'var(--ambre-tx)',
              margin: '0' }}>Guide des appareils</p>
            <p style={{ fontSize: '10.5px', color: 'var(--ambre-tx)',
              margin: '3px 0 0', lineHeight: '1.5' }}>Ce bloc n'apparaît pas :
              aucun appareil renseigné.</p>
          </div>
        )}
        <p style={{ fontSize: '9.5px', color: 'var(--gris-d)', margin: '11px 0 0',
          textAlign: 'center' }}>français · anglais · espagnol</p>
      </div>
    </div>
  )
}

/* ── l'interrupteur rond du proto (44 × 26) ───────────────────────── */
export function ToggleRond({ on, onClick, testId, disabled = false, ariaLabel }) {
  return (
    <button onClick={onClick} data-testid={testId} disabled={disabled}
      role="switch" aria-checked={on} aria-label={ariaLabel}
      style={{ width: '44px', height: '26px', borderRadius: '13px',
        flexShrink: '0', position: 'relative',
        background: on ? '#2f9e6e' : '#e0e5ea', border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        opacity: disabled ? 0.55 : 1 }}>
      <span style={{ position: 'absolute', top: '3px',
        ...(on ? { right: '3px' } : { left: '3px' }), width: '20px',
        height: '20px', borderRadius: '50%', background: '#fff' }} />
    </button>
  )
}

/* ── une carte de bloc automatique (Assistance / Alentours / Météo) ── */
export function CarteAuto({ icone, ambre = false, titre, sousTitre, on,
  onToggle, toggleDisabled = false, revuTexte, onRevoir, testId, enfants }) {
  return (
    <div className="carte" style={{ margin: '0 0 8px',
      ...(ambre ? { borderColor: 'var(--ambre-bd)' } : {}) }} data-testid={testId}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
        <span style={{ width: '30px', height: '30px', borderRadius: '9px',
          flexShrink: '0', display: 'flex', alignItems: 'center',
          justifyContent: 'center', fontSize: '13px',
          background: ambre ? 'var(--ambre-bg)' : 'var(--vert-bg)',
          color: ambre ? 'var(--ambre-tx)' : 'var(--vert-tx)' }}>{icone}</span>
        <span style={{ flex: '1', minWidth: '0' }}>
          <span style={{ display: 'block', fontSize: '12.5px', fontWeight: '600',
            color: 'var(--navy-d)' }}>{titre}</span>
          <span style={{ display: 'block', fontSize: '10.5px', color: 'var(--gris)',
            marginTop: '1px' }}>{sousTitre}</span>
        </span>
        {onToggle && (
          <ToggleRond on={on} onClick={onToggle} disabled={toggleDisabled}
            ariaLabel={`Afficher « ${titre} » au voyageur`}
            testId={testId ? `${testId}-toggle` : undefined} />
        )}
      </div>
      {(revuTexte || enfants) && (
        <div style={{ display: 'flex', alignItems: 'center', gap: '9px',
          paddingTop: '9px', marginTop: '9px', borderTop: '1px solid var(--bord)' }}>
          {revuTexte && (
            <span style={{ flex: '1', fontSize: '10.5px',
              color: ambre ? 'var(--ambre-tx)' : 'var(--gris)',
              lineHeight: '1.5' }}>{revuTexte}</span>
          )}
          {onRevoir && (
            <button onClick={onRevoir}
              data-testid={testId ? `${testId}-revoir` : undefined}
              style={{ minHeight: '34px', padding: '0 11px', borderRadius: '8px',
                border: '1px solid #c3d5e4', background: '#fff', fontSize: '11px',
                color: 'var(--navy)', flexShrink: '0', cursor: 'pointer' }}>Revoir</button>
          )}
          {enfants}
        </div>
      )}
    </div>
  )
}

/* ── une carte-catégorie de modules (section Contenu) ─────────────── */
export function CarteCategorie({ label, n, actif, enTeteExtras, enfants }) {
  return (
    <div className="carte" style={{ margin: '0 0 8px', padding: '0',
      overflow: 'hidden' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '9px',
        padding: '9px 12px', background: actif ? '#3d5166' : '#f6f8fa' }}>
        <span style={{ width: '7px', height: '7px', borderRadius: '50%',
          background: actif ? '#87b8e6' : '#c3cdd6', flexShrink: '0' }} />
        <span style={{ flex: '1', fontSize: '11.5px', fontWeight: '600',
          color: actif ? '#fff' : 'var(--gris)' }}>{label}</span>
        {enTeteExtras}
        <span style={{ fontSize: '10.5px',
          color: actif ? 'rgba(255,255,255,.6)' : 'var(--gris-d)' }}>{n}</span>
      </div>
      {enfants}
    </div>
  )
}
